var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.917 6.20002L12.708 0.92202C12.4891 0.808984 12.2463 0.75 12 0.75C11.7536 0.75 11.5108 0.808984 11.292 0.92202L1.08297 6.20002C0.9827 6.25195 0.898636 6.33043 0.839957 6.4269C0.781279 6.52337 0.750244 6.63411 0.750244 6.74702C0.750244 6.85993 0.781279 6.97067 0.839957 7.06714C0.898636 7.16361 0.9827 7.2421 1.08297 7.29402L11.292 12.575C11.5108 12.6881 11.7536 12.747 12 12.747C12.2463 12.747 12.4891 12.6881 12.708 12.575L22.917 7.30002C23.0172 7.2481 23.1013 7.16961 23.16 7.07314C23.2187 6.97667 23.2497 6.86593 23.2497 6.75302C23.2497 6.64011 23.2187 6.52937 23.16 6.4329C23.1013 6.33643 23.0172 6.25795 22.917 6.20602V6.20002Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09997 9.375L1.08297 11.453C0.9827 11.5049 0.898636 11.5834 0.839957 11.6799C0.781279 11.7763 0.750244 11.8871 0.750244 12C0.750244 12.1129 0.781279 12.2237 0.839957 12.3201C0.898636 12.4166 0.9827 12.4951 1.08297 12.547L11.292 17.828C11.5108 17.941 11.7536 18 12 18C12.2463 18 12.4891 17.941 12.708 17.828L22.917 12.547C23.0172 12.4951 23.1013 12.4166 23.16 12.3201C23.2187 12.2237 23.2497 12.1129 23.2497 12C23.2497 11.8871 23.2187 11.7763 23.16 11.6799C23.1013 11.5834 23.0172 11.5049 22.917 11.453L18.9 9.375",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09997 14.625L1.08297 16.7C0.9827 16.7519 0.898636 16.8304 0.839957 16.9269C0.781279 17.0233 0.750244 17.1341 0.750244 17.247C0.750244 17.3599 0.781279 17.4707 0.839957 17.5671C0.898636 17.6636 0.9827 17.7421 1.08297 17.794L11.292 23.075C11.5108 23.188 11.7536 23.247 12 23.247C12.2463 23.247 12.4891 23.188 12.708 23.075L22.917 17.8C23.0172 17.7481 23.1013 17.6696 23.16 17.5731C23.2187 17.4767 23.2497 17.3659 23.2497 17.253C23.2497 17.1401 23.2187 17.0293 23.16 16.9329C23.1013 16.8364 23.0172 16.7579 22.917 16.706L18.9 14.625",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.48a66863cacb2c65d5cdd7a80e10f185.svg";
export { ForwardRef as ReactComponent };